import * as Yup from 'yup';
import {
  nonEmptyReqValidator,
  nonWhiteSpaceValidator,
} from '@gokrew/ui/utility/validators';
import type { TranslationNS } from '@gokrew/models/constants';
import type { TFunction } from 'i18next';

/**
 * The designationSchema is used to validate the data provided in the designation creation/updation form.
 * It requires the name and description fields to be present and non-empty.
 */
export const designationSchema = (t: TFunction<TranslationNS.Designation>) =>
  Yup.object({
    name: nonEmptyReqValidator(t('validation.name')).required(
      t('validation.name')
    ),
    description: nonWhiteSpaceValidator(t('validation.description')),
  });
